import React, { useEffect, useState } from 'react'
import { Button, Form, Toast } from 'antd-mobile-v5'
import { Checkbox } from 'antd'
import { useAutoRenew, useAutoRenewBind, useAutoRenewSend, useAutoRenewUnBind } from '../../services/hooks'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './AutoRenewal.module.css'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLanguage } from '../../services/hooks/user'
import { useCountDown } from 'ahooks'

const AutoRenewPage = () => {
  const [form] = Form.useForm()
  const { formatMessage } = useIntl()
  const { push, replace } = useHistory()
  const { state } = useLocation()
  const lang = useLanguage()
  const { code = '', type, paid = false } = state || {}
  const [isBound, setIsBound] = useState(false)
  const [canSignup, setCanSignup] = useState(true)
  const [core, setCore] = useState('')
  const [showEFR, setShowEFR] = useState(false)
  const [mchntSsn, setMchntSsn] = useState('')
  const [checked, setChecked] = useState(false)
  const [targetDate, setTargetDate] = useState()
  const [msgCode, setMsgCode] = useState('')

  const [countdown] = useCountDown({
    targetDate,
  })

  const { loading } = useAutoRenew({
    onSuccess: (data) => {
      setIsBound(data.bind)
      setShowEFR(data.efr)
      setCore(data.core)
      setCanSignup(data.canSignup !== false)
    },
  })
  const { runAsync: sendCode, loading: sendLoading } = useAutoRenewSend()
  const { runAsync: renewBind, loading: bindLoading } = useAutoRenewBind()
  const { runAsync: renewUnBind, loading: unbindLoading } = useAutoRenewUnBind()

  useEffect(() => {
    document.body.style.setProperty('background-color', '#ffffff', 'important')

    return () => {
      document.body.style.setProperty('background-color', '#f5f5f9', 'important')
    }
  }, [])

  useEffect(() => {
    const listItems = document.querySelectorAll('.adm-list-item-content')
    const listItemsMain = document.querySelectorAll('.adm-list-item-content-main')
    listItems.forEach((item) => {
      item.style.setProperty('border', 'none', 'important')
    })
    listItemsMain.forEach((item) => {
      item.style.setProperty('padding', '12px 0 0', 'important')
    })
  })

  const handleSubmitBindMsg = async () => {
    try {
      const values = await form.validateFields()
      let source = type
      const dataToSend = { ...values, source }
      sendCode(dataToSend).then((res) => {
        if (res.responseMsg === '成功') {
          Toast.show({
            icon: 'success',
            content: '验证码已发送',
          })
          setMchntSsn(res.mchntSsn)
          setTargetDate(Date.now() + 99000)
        } else {
          Toast.show({
            content: '发送验证码失败，' + (res.responseMsg || '请检查输入信息并重试。'),
          })
        }
      })
    } catch (error) {}
  }

  const handleSubmitBind = async (values) => {
    if (!mchntSsn) {
      Toast.show({
        content: '请获取验证码',
      })
      return
    }
    if (!msgCode) {
      Toast.show({
        content: '请输入验证码',
      })
      return
    }
    if (!checked) {
      Toast.show({
        content: formatMessage({ id: 'common-check-agreement' }),
      })
      return
    }
    const dataToSubmit = { ...values, mchntSsn, msgCode }
    renewBind(dataToSubmit).then((res) => {
      if (res.responseCode === '0000') {
        push('/renewal_success', {
          core: showEFR ? `${core || 'Core'} + EFRI` : `${core || 'Core'}`,
        })
      } else {
        Toast.show({
          content: '绑定失败，' + (res.responseMsg || '请检查输入信息并重试。'),
        })
      }
    })
  }

  const handleUnBind = async () => {
    renewUnBind().then((res) => {
      if (res.responseCode === '0000') {
        setIsBound(false)
        setMchntSsn('')
        form.resetFields()
        Toast.show({
          icon: 'success',
          content: formatMessage({ id: 'auto-renew-member-unbind-success' }),
        })
      } else {
        Toast.show({
          content: '解除失败',
        })
      }
    })
  }

  if (loading) {
    return <div>加载中...</div>
  }

  if (!canSignup) {
    return <div style={{ padding: '48px 24px', textAlign: 'center', color: '#909399' }}>自动更新暂未开放</div>
  }

  return (
    <>
      <div className={styles.header}>
        <img src={require('../../assets/images/logo/padi-logo-dark.png')} className={styles['padi-logo']} />
      </div>
      {isBound ? (
        <div className={styles.unbinding}>
          <div className={styles.status}>
            <div className={styles.text}>当前已绑定</div>
            <div className={styles.core}>{showEFR ? `${core || 'Core'} + EFRI` : `${core || 'Core'}`}</div>
          </div>
          <Button
            color="danger"
            fill="none"
            block
            loading={unbindLoading}
            disabled={unbindLoading}
            onClick={handleUnBind}
          >
            解除自动更新
          </Button>
        </div>
      ) : (
        <div className={styles['auto-renew-form']}>
          <h1 className={styles['auto-renew-title']}>更新选项</h1>
          <div className={styles['core-name']}>{showEFR ? `${core || 'Core'} + EFRI` : `${core || 'Core'}`}</div>
          <div className={styles['auto-renew-title']}>支付方式</div>
          <Form
            form={form}
            layout="vertical"
            validateTrigger="onSubmit"
            requiredMarkStyle="none"
            className={styles.form}
            onFinish={(values) => handleSubmitBind(values)}
            footer={
              <div className={styles.footer}>
                <div className={styles.agreements}>
                  <Checkbox
                    className={styles['agreement-box']}
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  >
                    <FormattedMessage
                      id="auto-renew-agreemt"
                      values={{
                        agreement: (
                          <a
                            rel="noopener noreferrer"
                            target="_blank"
                            className={styles['agreement-content']}
                            href={
                              lang === 'sc'
                                ? 'https://pro-cms.padi.com/sites/default/files/documents/training-hub/728DTSC%20Automatic%20Renewal%20Details.pdf'
                                : 'https://pro-cms.padi.com/sites/default/files/documents/training-hub/728DT%20Automatic%20Renewal%20Details_0.pdf'
                            }
                          >
                            <FormattedMessage id="auto-renew-agreement-name" />
                          </a>
                        ),
                      }}
                    />
                  </Checkbox>
                </div>
                <Button block className={styles['binding-btn']} type="submit" loading={bindLoading}>
                  完成绑定
                </Button>
                <Button block className={styles['cancel-btn']} onClick={() => replace('/renewal_options')}>
                  取消
                </Button>
                <div className={styles.tips}>
                  <h4 className={styles.title}>我们接受</h4>
                  <div className={styles['icon-box']}>
                    <img
                      src={require('../../assets/images/logo/union-pay.png')}
                      alt="payment"
                      className={styles.icon}
                    />
                    <img
                      src={require('../../assets/images/logo/fuiou-pay.png')}
                      alt="payment"
                      className={styles.icon}
                    />
                  </div>
                  <div className={styles['tips-text']}>
                    会员自动更新的安全付款服务由上海富友支付（中国人民银行授权）提供。
                  </div>
                  <div className={styles['tips-text']}>
                    您填写的身份证、银行卡等信息，PADI 将直接加密发送给银行，用于签约代扣协议。PADI
                    不会保存您的这些信息，敬请放心。
                  </div>
                </div>
              </div>
            }
          >
            <Form.Item
              label="银行卡信息"
              name="cardNo"
              rules={[{ required: true, message: '银行卡号不能为空' }]}
              className={styles.item}
            >
              <input type="number" placeholder="请输入银行卡号" className={styles.input}></input>
            </Form.Item>
            <Form.Item
              label="持卡人姓名"
              name="account"
              rules={[{ required: true, message: '持卡人中文姓名不能为空' }]}
              className={styles.item}
            >
              <input placeholder="请输入姓名" className={styles.input}></input>
            </Form.Item>
            <Form.Item
              label="身份证号"
              name="idCard"
              rules={[{ required: true, message: '身份证号不能为空' }]}
              className={styles.item}
            >
              <input maxLength={18} placeholder="请输入身份证" className={styles.input}></input>
            </Form.Item>
            <Form.Item
              label="手机号码"
              name="mobileNo"
              rules={[{ required: true, message: '手机号码不能为空' }]}
              className={styles.item}
            >
              <input type="number" maxLength={11} placeholder="请输入手机号" className={styles.input}></input>
            </Form.Item>
            <div className={styles.code}>
              <div className={styles.label}>验证码</div>
              <input
                type="number"
                placeholder="请输入验证码"
                className={styles.input}
                onChange={(e) => setMsgCode(e.target.value)}
              ></input>
              <Button
                disabled={sendLoading || countdown > 0}
                loading={sendLoading}
                className={styles['code-btn']}
                size="small"
                fill="none"
                onClick={handleSubmitBindMsg}
              >
                {countdown > 0 ? Math.round(countdown / 1000) + 's' : <FormattedMessage id="common-getCode" />}
              </Button>
            </div>
          </Form>
        </div>
      )}
    </>
  )
}

export default AutoRenewPage
